import React, { useEffect, useState } from "react";
import { Download, X, Smartphone, Share } from "lucide-react";

// PWA install prompt handler
// - On Chrome/Android/Desktop: uses beforeinstallprompt event
// - On iOS Safari: shows manual instructions

function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
}
function isInStandaloneMode() {
  return window.matchMedia("(display-mode: standalone)").matches
    || window.navigator.standalone === true;
}

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPanel, setShowPanel] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem("mb_pwa_dismissed") === "1"; } catch { return false; }
  });

  useEffect(() => {
    if (isInStandaloneMode()) return; // already installed

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // On iOS there's no beforeinstallprompt — show manual button after 3s
    if (isIOS() && !dismissed) {
      const t = setTimeout(() => setShowPanel(true), 3000);
      return () => { clearTimeout(t); window.removeEventListener("beforeinstallprompt", handler); };
    }

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, [dismissed]);

  if (isInStandaloneMode()) return null;

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") setDeferredPrompt(null);
  };

  const dismiss = () => {
    try { localStorage.setItem("mb_pwa_dismissed", "1"); } catch {}
    setDismissed(true);
    setDeferredPrompt(null);
    setShowPanel(false);
  };

  // Nothing to prompt on this device
  if (!deferredPrompt && !showPanel) return null;
  if (dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-40 bg-slate-900 text-white border-2 border-blue-600 shadow-2xl p-4" data-testid="pwa-install-panel">
      <button onClick={dismiss} data-testid="pwa-dismiss" className="absolute top-2 right-2 text-slate-400 hover:text-white"><X size={16} /></button>
      <div className="flex items-start gap-3 pr-6">
        <div className="w-10 h-10 bg-blue-600 grid place-items-center shrink-0"><Smartphone size={22} /></div>
        <div className="flex-1">
          <div className="font-display font-black text-base">Ana Ekrana Ekle</div>
          <div className="text-xs text-slate-300 mt-1">
            {isIOS()
              ? <>Safari'de <b>Paylaş <Share size={12} className="inline"/></b> tuşuna basın → <b>"Ana Ekrana Ekle"</b> seçin.</>
              : <>Marsella'yı bir uygulama gibi telefonunuza kurun — tam ekran, hızlı erişim.</>}
          </div>
          {deferredPrompt && (
            <button
              onClick={install}
              data-testid="pwa-install-btn"
              className="mt-3 w-full inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 font-bold uppercase text-sm"
            >
              <Download size={16} /> Uygulamayı Yükle
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
